export const parseModel = function (model) {
  const parsedModel = {}
  parsedModel.chiSqrt = model.chiSqrt || null
  parsedModel.dmax = model.dmax || null
  parsedModel.firFile = model.firFile || null
  parsedModel.fitFile = model.fitFile || null
  parsedModel.logFile = model.logFile || null
  parsedModel.modelId = model.modelId || null
  parsedModel.name = model.name || null
  parsedModel.pdbFile = model.pdbFile || null
  parsedModel.rfactor = model.rfactor || null
  parsedModel.rg = model.rg || null
  parsedModel.volume = model.volume || null
  return parsedModel
}
